import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { color } from '../../styles/mixins';
import { typography } from '../../styles/typography';
import { Button } from '../button/button';
import { Heading } from '../heading/heading';
import { Actions, Content, Copy, Form, Host, Sticky } from './shared';

export interface AccountEntry {
  id: string;
  accountId: string;
  accountStatus: string;
  holderName: string;
  bidStatus: string;
  type: string;
}

export const SelectBox = styled.div`
  border-bottom: 1px solid ${color('gray30')};
  position: relative;

  select {
    width: 100%;
    padding: 10px;

    ${typography.fonts.benton(16, 'label')}
    font-weight: normal;

    color: #333333;
  }

  svg {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -6px;
  }
`;
export const DropDownIcon = () => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 3.63655L3.5 0L0 3.63655H7Z" fill="#6B6B6B" />
    <path
      d="M6.88275 8.48528H0.117255L3.5 12L6.88275 8.48528Z"
      fill="#6B6B6B"
    />
  </svg>
);

export function SelectAccount({
  onSelect,
  onCancel,
  accounts,
}: {
  onSelect?(account: AccountEntry): void;
  onCancel?(): void;
  accounts: AccountEntry[];
}) {
  const [account, setAccount] = useState<AccountEntry>();

  const onAccountChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const account = accounts.find((a) => a.accountId === e.target.value);
    if (account) {
      setAccount(account);
    } else {
      setAccount(undefined);
    }
  };

  const onAccountSelect = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (account) {
      onSelect?.(account);
    } else {
      alert('Please select an valid account');
    }
    return false;
  };

  return (
    <Host>
      {accounts.length === 0 ? (
        <Content>
          <Heading center>No bidding accounts found</Heading>
          <Copy>
            You dont have any bidding accounts available to bid on this auction.
          </Copy>
        </Content>
      ) : (
        <Content>
          <Heading center>Select Your Account</Heading>
          <Copy>
            <p>Choose the account you would like to use for bidding.</p>
          </Copy>
          <SelectBox>
            <select onChange={onAccountChange}>
              <option value="">Your Sotheby’s Account Number</option>
              <optgroup label="Accounts">
                {accounts.map((account) => (
                  <option key={account.id} value={account.accountId}>
                    {account.accountId} ({account.holderName})
                  </option>
                ))}
              </optgroup>
            </select>
            <DropDownIcon />
          </SelectBox>
        </Content>
      )}
      <Sticky>
        <Form onSubmit={onAccountSelect}>
          <Actions>
            <Button as={Link} variant="secondary" to="/">
              Cancel
            </Button>
            <Button type="submit" disabled={!account}>
              Continue
            </Button>
          </Actions>
        </Form>
      </Sticky>
    </Host>
  );
}
